import React from 'react';

export const Callout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="bg-zinc-100 dark:bg-zinc-800 rounded-lg p-6 mb-6 border-l-4 border-blue-500">
    <p className="text-lg dark:text-zinc-200">{children}</p>
  </div>
);
